import {useEffect,useState} from 'react';
import {queueLabels,OperationsView} from './companyOperationsQueues';

export type CompanyTask = {page:'operations'|'intake'|'customer_orders'|'unknown'} | {page:'queue';view:OperationsView} | {page:'job'|'proof'|'invoices';jobId:string;view:OperationsView};
export function companyTask(path=window.location.pathname,query=window.location.search):CompanyTask {
  if(path==='/')return {page:'operations'};
  if(path==='/company/customer-orders')return {page:'customer_orders'};
  if(path==='/company/new-file')return {page:'intake'};
  const queue=path.match(/^\/company\/work\/([a-z_]+)$/);
  if(queue&&Object.hasOwn(queueLabels,queue[1]))return {page:'queue',view:queue[1] as OperationsView};
  const job=path.match(/^\/company\/jobs\/([a-zA-Z0-9-]+)(\/proof|\/invoices)?$/);
  if(job){const from=new URLSearchParams(query).get('from')??(job[2]==='/proof'?'affidavits':'open');return {page:job[2]==='/proof'?'proof':job[2]==='/invoices'?'invoices':'job',jobId:job[1],view:Object.hasOwn(queueLabels,from)?from as OperationsView:'open'};}
  return {page:'unknown'};
}
export function goToCompanyTask(path:string){window.history.pushState({},'',path);window.dispatchEvent(new PopStateEvent('popstate'));}
export function useCompanyTask(){
  const [task,setTask]=useState(()=>companyTask());
  useEffect(()=>{const changed=()=>setTask(companyTask());window.addEventListener('popstate',changed);return()=>window.removeEventListener('popstate',changed)},[]);
  return task;
}
